import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DrawerItem = styled.div`
  align-items: center;
  background-color: ${props => props.theme.carvana.gray.background};
  border-bottom: 1px solid ${props => props.theme.carvana.gray.medium};
  display: flex;
  flex: 1;
  min-height: 50px;
  padding: 20px 32px 19px 32px;
`;

const MenuDrawerItem = ({ children, className }) => (
  <DrawerItem className={className}>
    {children}
  </DrawerItem>
);

MenuDrawerItem.defaultProps = {
  className: '',
};

MenuDrawerItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default MenuDrawerItem;
